













import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";

import Plushie from "@/modules/plushie/plushie.model";
import PlushieStore from "@/modules/plushie/store";
import dataStore from "@/store";

import UndoForm from "./AcceptSuccessPage/UndoForm.vue";

@Component({
  metaInfo() {
    const component = this as AcceptSuccessPage;

    let titlePrefix = "";
    if (component.plushie != null) {
      titlePrefix = component.plushie.storeItemId + " - ";
    }

    return {
      title: titlePrefix + "Design Approved",
    };
  },
  components: {
    UndoForm,
  },
})
export default class AcceptSuccessPage extends Vue {
  @Prop({ required: true })
  public readonly plushieId!: string;

  private fPlushieDataStore: PlushieStore;

  get plushie(): Plushie | undefined {
    return this.fPlushieDataStore.getPlushieById(this.plushieId);
  }

  constructor() {
    super();
    this.fPlushieDataStore = getModule(PlushieStore, dataStore);
  }

  private async getPlushieData(plushieId: string): Promise<void> {
    await this.fPlushieDataStore.loadPlushieById({ id: plushieId });
  }

  @Watch("plushieId", { immediate: true })
  private async onPlushieIdChange(): Promise<void> {
    if (!this.plushieId) {
      return;
    }

    await this.getPlushieData(this.plushieId);
  }
}
